<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <Filtro />
      <v-flex
        lg12
        sm12
        xs12
        class="pt-0"
      >
        <div class="mb-3">
          <GeneratePDF
            :items-per-page="table.paginate.size"
            :head="addNewHeard"
            :title="'Informes Repasses de Regulação'"
            :report-data="searchJSON"
            :disable="table?.total === 0"
          />
          <GenerateExcel
            :items-per-page="table.paginate.size"
            :head="addNewHeard"
            :title="'Informes Repasses de Regulação'"
            :report-data="searchJSON"
            :disable="table?.total === 0"
          />
        </div>
        <v-data-table
          :headers="tableHeaders"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageOptions: [5, 10, 50, table.total]
              .sort((a, b) => a - b)
              .filter(v => v !== 0),
          }"
        >
          <template #headerCell="{ header }">
            <span :title="header.tooltip || header.text">
              {{ header.text }}
            </span>
          </template>
          <template #item.acoes="{ item }">
            <v-btn
              v-if="item.situacaoDae != 'Pago' && item.situacaoDae != 'Parcelado' && item.situacao === 'Aceito' && item.dae"
              :loading="loading"
              text
              variant="plain"
              @click="checkAbrirModal(item)"
            >
              <v-icon
                color="primary"
                text
                size="middle"
                title="Baixar PDF do DAE"
              >
                download
              </v-icon>
            </v-btn>
            <v-btn
              v-if="item.situacao === 'Aceito' && !item.dae"
              :loading="loading"
              text
              variant="plain"
              @click="downloadQuitacao(item, userGessan.cnpj)"
            >
              <v-icon
                color="primary"
                text
                size="middle"
                title="Baixar PDF de Quitação"
              >
                download
              </v-icon>
            </v-btn>
            <DialogMotivoCancelamento
              v-if="item.situacao === 'Cancelado' || item.situacao === 'Negado'"
              :motivo="item.motivo"
            />
            <DialogMemoriaCalculo
              v-if="item.memoriaCalculo"
              :memoria-calculo="item.memoriaCalculo"
            />
          </template>
          <template #item.qtdeUnAbastecimentoAgua="{ item }">
            <span>{{ FunctionsCommuns.IntegerFormat(item.qtdeUnAbastecimentoAgua) }}</span>
          </template>
          <template #item.qtdeUnEsgotamentoSanitario="{ item }">
            <span>{{ FunctionsCommuns.IntegerFormat(item.qtdeUnEsgotamentoSanitario) }}</span>
          </template>
          <template #item.faturamentoMensalLiquido="{ item }">
            <span class="money-cell">{{ formatCurrency(item.faturamentoMensalLiquido) }}</span>
          </template>
          <template #item.quantidadeLigacoesAtivasAguaCapital="{ item }">
            <span>{{ FunctionsCommuns.IntegerFormat(item.quantidadeLigacoesAtivasAguaCapital) }}</span>
          </template>
          <template #item.quantidadeLigacoesAtivasAguaInterior="{ item }">
            <span>{{ FunctionsCommuns.IntegerFormat(item.quantidadeLigacoesAtivasAguaInterior) }}</span>
          </template>
          <template #item.quantidadeLigacoesAtivasEsgotoCapital="{ item }">
            <span>{{ FunctionsCommuns.IntegerFormat(item.quantidadeLigacoesAtivasEsgotoCapital) }}</span>
          </template>
          <template #item.quantidadeLigacoesAtivasEsgotoInterior="{ item }">
            <span>{{ FunctionsCommuns.IntegerFormat(item.quantidadeLigacoesAtivasEsgotoInterior) }}</span>
          </template>
          <template #item.faturamentoLiquidoAguaCapital="{ item }">
            <span class="money-cell">{{ formatCurrency(item.faturamentoLiquidoAguaCapital) }}</span>
          </template>
          <template #item.faturamentoLiquidoAguaInterior="{ item }">
            <span class="money-cell">{{ formatCurrency(item.faturamentoLiquidoAguaInterior) }}</span>
          </template>
          <template #item.faturamentoLiquidoEsgotoCapital="{ item }">
            <span class="money-cell">{{ formatCurrency(item.faturamentoLiquidoEsgotoCapital) }}</span>
          </template>
          <template #item.faturamentoLiquidoEsgotoInterior="{ item }">
            <span class="money-cell">{{ formatCurrency(item.faturamentoLiquidoEsgotoInterior) }}</span>
          </template>
          <template #item.situacaoDae="{ item }">
            <v-chip
              v-if="getSituacaoTexto(item)"
              :color="getChipColor(item)"
              :outlined="!getChipColor(item)"
              dark
              small
              class="ma-0 pa-1"
            >
              {{ getSituacaoTexto(item) }}
            </v-chip>
          </template>
        </v-data-table>
        <DialogBaixarDae
          v-if="openDialogDae && selectedItem"
          :nosso-numero="selectedItem.dae"
          :cpf-cnpj="userGessan.cnpj"
          :data-vencimento="selectedItem.dataVencimentoDae"
          :is-grupo="userGessan?.isGrupo"
          @close="openDialogDae = false"
          @gerarDae="gerarNovoDAE"
        />

        <LoaderDialog
          :active-dialog="loader"
          message="Gerando DAE"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-prototype-builtins */
import { mapActions, mapState } from 'vuex';
import Filtro from './Filtro.vue';
import GenerateExcel from '@/components/GenerateExcel.vue';
import GeneratePDF from '@/components/GeneratePDF.vue';
import AuthService from '@/services/gessan/auth.service';
import SaneamentoService from '@/services/gessan/saneamento.service';
import FunctionsCommuns from '@/util/FunctionsCommuns';
import DialogMotivoCancelamento from './components/DialogMotivoCancelamento.vue';
import DialogBaixarDae from './components/DialogBaixarDae.vue';
import DialogMemoriaCalculo from './components/DialogMemoriaCalculo.vue';
import moment from 'moment';
import LoaderDialog from '@/components/LoaderDialog.vue';

const actions = mapActions('gessan', [
  'setTableContent',
  'setTableIsLoading',
  'setTableTotals',
  'clearTable',
  'setTablePagination',
]);
const state = mapState('gessan', ['table']);
const global = mapState('global', ['userGessan']);

const municipalityTableHeaders = [
  {
    text: 'Mês/Ano',
    exportText: 'Mês/Ano',
    align: 'start',
    sortable: true,
    value: 'mesAno',
  },
  {
    text: 'Município',
    exportText: 'Município',
    align: 'start',
    sortable: true,
    value: 'municipio',
  },
  {
    text: 'Lig. Água',
    exportText: 'Quantidade de Ligações Ativas de Água',
    tooltip: 'Quantidade de Ligações Ativas de Água',
    align: 'start',
    sortable: true,
    value: 'qtdeUnAbastecimentoAgua',
  },
  {
    text: 'Lig. Esgoto',
    exportText: 'Quantidade de Ligações Ativas de Esgoto',
    tooltip: 'Quantidade de Ligações Ativas de Esgoto',
    align: 'start',
    sortable: true,
    value: 'qtdeUnEsgotamentoSanitario',
  },
  {
    text: 'Fat. Mensal',
    exportText: 'Faturamento Direto Mensal Líquido',
    tooltip: 'Faturamento Direto Mensal Líquido',
    align: 'start',
    sortable: true,
    value: 'faturamentoMensalLiquido',
  },
  {
    text: 'Situação',
    exportText: 'Situação',
    align: 'start',
    sortable: true,
    value: 'situacao',
  },
  {
    text: 'DAE',
    exportText: 'DAE',
    align: 'start',
    sortable: true,
    value: 'situacaoDae',
  },
  {
    text: 'Ações',
    exportText: 'Ações',
    align: 'start',
    sortable: false,
    value: 'acoes',
  },
];

const groupTableHeaders = [
  {
    text: 'Mês/Ano',
    exportText: 'Mês/Ano',
    align: 'start',
    sortable: true,
    value: 'mesAno',
  },
  {
    text: 'Grupo',
    exportText: 'Grupo Município',
    tooltip: 'Grupo Município',
    align: 'start',
    sortable: true,
    value: 'grupoMunicipio',
  },
  {
    text: 'Lig. Água Cap.',
    exportText: 'Quantidade de Ligações Ativas de Água Capital',
    tooltip: 'Quantidade de Ligações Ativas de Água Capital',
    align: 'start',
    sortable: true,
    value: 'quantidadeLigacoesAtivasAguaCapital',
  },
  {
    text: 'Lig. Água Int.',
    exportText: 'Quantidade de Ligações Ativas de Água Interior',
    tooltip: 'Quantidade de Ligações Ativas de Água Interior',
    align: 'start',
    sortable: true,
    value: 'quantidadeLigacoesAtivasAguaInterior',
  },
  {
    text: 'Lig. Esgoto Cap.',
    exportText: 'Quantidade de Ligações Ativas de Esgoto Capital',
    tooltip: 'Quantidade de Ligações Ativas de Esgoto Capital',
    align: 'start',
    sortable: true,
    value: 'quantidadeLigacoesAtivasEsgotoCapital',
  },
  {
    text: 'Lig. Esgoto Int.',
    exportText: 'Quantidade de Ligações Ativas de Esgoto Interior',
    tooltip: 'Quantidade de Ligações Ativas de Esgoto Interior',
    align: 'start',
    sortable: true,
    value: 'quantidadeLigacoesAtivasEsgotoInterior',
  },
  {
    text: 'Fat. Água Cap.',
    exportText: 'Faturamento Líquido de Água Capital',
    tooltip: 'Faturamento Líquido de Água Capital',
    align: 'start',
    sortable: true,
    value: 'faturamentoLiquidoAguaCapital',
  },
  {
    text: 'Fat. Água Int.',
    exportText: 'Faturamento Líquido de Água Interior',
    tooltip: 'Faturamento Líquido de Água Interior',
    align: 'start',
    sortable: true,
    value: 'faturamentoLiquidoAguaInterior',
  },
  {
    text: 'Fat. Esgoto Cap.',
    exportText: 'Faturamento Líquido de Esgoto Capital',
    tooltip: 'Faturamento Líquido de Esgoto Capital',
    align: 'start',
    sortable: true,
    value: 'faturamentoLiquidoEsgotoCapital',
  },
  {
    text: 'Fat. Esgoto Int.',
    exportText: 'Faturamento Líquido de Esgoto Interior',
    tooltip: 'Faturamento Líquido de Esgoto Interior',
    align: 'start',
    sortable: true,
    value: 'faturamentoLiquidoEsgotoInterior',
  },
  {
    text: 'Situação',
    exportText: 'Situação',
    align: 'start',
    sortable: true,
    value: 'situacao',
  },
  {
    text: 'DAE',
    exportText: 'DAE',
    align: 'start',
    sortable: true,
    value: 'situacaoDae',
  },
  {
    text: 'Ações',
    exportText: 'Ações',
    align: 'start',
    sortable: false,
    value: 'acoes',
  },
];

export default {
  components: {
    Filtro,
    GenerateExcel,
    GeneratePDF,
    DialogMotivoCancelamento,
    DialogBaixarDae,
    DialogMemoriaCalculo,
    LoaderDialog,
  },
  data: () => ({
    pagination: null,
    loading: false,
    addNewHeard: [],
    selectedItem: null,
    openDialogDae: false,
    loader: false,
  }),
  computed: {
    ...state,
    ...global,
    FunctionsCommuns() {
      return FunctionsCommuns;
    },
    isGrupoMunicipio() {
      return !!this.userGessan?.isGrupo;
    },
    tableHeaders() {
      return this.isGrupoMunicipio ? groupTableHeaders : municipalityTableHeaders;
    },
    exportHeaders() {
      return this.tableHeaders.map(header => ({
        ...header,
        text: header.exportText || header.text,
      }));
    },
  },
  watch: {
    pagination: {
      handler() {
        this.changePagination();
      },
      deep: true,
    },
  },
  destroyed() {
    this.clearTable();
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }

      return `R$\u00A0${FunctionsCommuns.MonetaryFormat(value)}`;
    },
    changePagination() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const input = { ...this.table.paginate };
      const sortByKey = sortBy?.length ? sortBy[0] : 'id';
      const sortOrder = sortDesc.length ? (sortDesc[0] ? 'DESC' : 'ASC') : 'ASC';
      const paginate = {
        ...input,
        sortBy: sortByKey,
        sortOrder,
        page: page - 1,
        size: itemsPerPage,
      };
      this.clearAggregateFiltersIfGroup(paginate);
      this.setTablePagination(paginate);
      this.search();
    },
    clearAggregateFiltersIfGroup(target) {
      if (!this.isGrupoMunicipio) {
        return target;
      }

      target.qtdeUnAbastecimentoAgua = null;
      target.qtdeUnEsgotamentoSanitario = null;
      target.faturamentoMensalLiquido = null;

      return target;
    },
    searchJSON() {
      this.addNewHeard = [
        ...this.exportHeaders,
        {
          text: 'Motivo',
          align: 'start',
          sortable: true,
          value: 'motivo',
        },
      ];
      return new Promise((resolve, reject) => {
        SaneamentoService.getList(
          this.clearAggregateFiltersIfGroup({
            ...this.table.paginate,
            cnpj: this.userGessan.cnpj,
            size: this.table.total,
            page: 0,
          }),
          this.userGessan?.isGrupo
        ).subscribe(
          ({ result }) => {
            const formattedItems = result.data.map(i => {
              const item = {
                mesAno: i.mesAno,
                situacao: i.situacao,
                situacaoDae: i.situacaoDae,
                motivo: i.motivo,
              };

              if (this.isGrupoMunicipio) {
                item.grupoMunicipio = i.grupoMunicipio;
                item.quantidadeLigacoesAtivasAguaCapital =
                  i.quantidadeLigacoesAtivasAguaCapital;
                item.quantidadeLigacoesAtivasAguaInterior =
                  i.quantidadeLigacoesAtivasAguaInterior;
                item.quantidadeLigacoesAtivasEsgotoCapital =
                  i.quantidadeLigacoesAtivasEsgotoCapital;
                item.quantidadeLigacoesAtivasEsgotoInterior =
                  i.quantidadeLigacoesAtivasEsgotoInterior;
                item.faturamentoLiquidoAguaCapital = i.faturamentoLiquidoAguaCapital;
                item.faturamentoLiquidoAguaInterior = i.faturamentoLiquidoAguaInterior;
                item.faturamentoLiquidoEsgotoCapital = i.faturamentoLiquidoEsgotoCapital;
                item.faturamentoLiquidoEsgotoInterior =
                  i.faturamentoLiquidoEsgotoInterior;
              } else {
                item.municipio = i.municipio;
                item.qtdeUnAbastecimentoAgua = i.qtdeUnAbastecimentoAgua;
                item.qtdeUnEsgotamentoSanitario = i.qtdeUnEsgotamentoSanitario;
                item.faturamentoMensalLiquido = i.faturamentoMensalLiquido;
              }

              return item;
            });
            resolve(formattedItems);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    search() {
      this.setTableIsLoading(true);
      const situacao = this.table.paginate.situacao ? this.table.paginate.situacao.join(';') : '';
      SaneamentoService.getList(
        this.clearAggregateFiltersIfGroup({
          ...this.table.paginate,
          situacao,
          cnpj: this.userGessan.cnpj,
        }),
        this.userGessan?.isGrupo
      ).subscribe(
        ({ result }) => {
          this.setTableContent(result?.data);
          this.setTableTotals(result.totalElements);
          this.setTableIsLoading(false);
        },
        error => {
          this.setTableIsLoading(false);
        }
      );
    },
    baixarDAE(item) {
      this.loading = true;
      this.loader = true;

      SaneamentoService.downloadDAE(item.dae).subscribe({
        next: response => {
          let filename = `DAE-${item.dae}.pdf`;
          const result = response.data;

          const blob = new Blob([result], {
            type: 'application/octet-stream',
          });

          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(link.href);
          AuthService.globalStore('success', 'Arquivo baixado de DAE com sucesso');
          this.search();
          this.loading = false;
          this.loader = false;
        },
        error: err => {
          this.loading = false;
          this.loader = false;
        },
      });
    },
    downloadQuitacao(item, cnpj) {
      this.loading = true;
      SaneamentoService.downloadQuitacao(item.id, cnpj, this.userGessan?.isGrupo).subscribe({
        next: response => {
          const { urlDownload } = response.result;
          const filename = `QUITACAO-${item.id}.pdf`;

          // Força o download com um link oculto
          const link = document.createElement('a');
          link.href = urlDownload;
          link.setAttribute('download', filename);
          link.setAttribute('target', '_blank'); // tenta abrir nova aba
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          AuthService.globalStore('success', 'Arquivo de Quitação baixado com sucesso');
          this.loading = false;
        },
      });
    },
    getSituacaoTexto(item) {
      if (!item.situacaoDae) {
        return null;
      }
      if (item.situacaoDae == 'Emitido') return 'Não Pago';
      return item.situacaoDae;
    },
    getChipColor(item) {
      if (!item.situacaoDae) {
        return null;
      }
      switch (item.situacaoDae) {
        case 'Emitido':
          return 'red darken-2';
        case 'Pago':
          return '#009900';
        case 'Cancelado':
          return 'red darken-2';
        case 'Quitação':
          return '#009900';
        default:
          return 'blue darken-2';
      }
    },
    checkValidade(dataVencimento) {
      const date = moment(dataVencimento, 'DD/MM/YYYY', true);
      if (!date.isValid()) {
        return false; // ou true, dependendo da sua lógica
      }
      return date.isBefore(moment(), 'day');
    },
    checkAbrirModal(item) {
      if (this.checkValidade(item.dataVencimentoDae)) {
        this.openDialogDae = true;
        this.selectedItem = item;
      } else {
        this.baixarDAE(item);
      }
    },
    gerarNovoDAE(dae) {
      this.baixarDAE({ dae });
      this.search();
    },
    ...actions,
  },
};
</script>

<style scoped>
.money-cell {
  white-space: nowrap;
}
</style>
